<script setup>
const currentYear = new Date().getFullYear()
</script>

<template>
    <div
        class="footer fixed bottom-0 left-0 z-50 h-5 w-full items-center border-t border-slate-200 bg-white px-5 md:flex print:hidden!"
    >
        <p class="footer-text mt-1.5 mr-8 text-left text-[8px] text-gray-500 md:mt-0">
            © {{ currentYear }}
            <a class="text-brand-blue-950/80 hover:text-brand-blue-950 font-medium" href="https://www.serifhealth.com"
                >Serif Health</a
            >.
            <a
                class="text-brand-blue-950/80 hover:text-brand-blue-950 ml-4 inline-block font-medium"
                href="https://www.serifhealth.com/page-terms"
                >Terms of Use</a
            >
            <a
                class="text-brand-blue-950/80 hover:text-brand-blue-950 ml-4 inline-block font-medium"
                href="https://www.serifhealth.com/page-privacy"
                >Privacy Policy</a
            >
        </p>
        <div class="flex-auto" />
        <p class="footer-text mt-0 text-left text-[8px] text-gray-500 md:mt-0">
            CPT&trade; © {{ currentYear }} American Medical Association. All rights reserved.
        </p>
    </div>
</template>
